import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
	height: 21vh;
	background-color: ${colors.white};
	box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 10px;
`;

export const SubWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: flex-start;
`;

export const RiskWrapper = styled.div`
	width: 3%;
	height: 21vh;
	background-color: ${props => props.tileColor};
`;

export const CardWrapper = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	padding: 2%;
`;

export const IconWrapper = styled.div`
	display: flex;
	flex-direction: row;
	margin-left: auto;
	.explore:focus-visible {
		border: none;
	}

	.material-icons-outlined {
		color: ${props => props.iconColor};
	}

	.help_tooltip {
		margin: 0 0 0 5px;
	}
`;

export const ContentWrapper = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 0 8% 0 0;
`;

export const Heading = styled.div`
	width: 100%;
	font-weight: 500;
	font-size: 15px;
	color: ${colors.black};
	padding: 0 8% 0 0;
`;

export const Analysis = styled.div`
	font-weight: 400;
	font-size: 14px;
	color: ${colors.grey700};
`;

export const ExploreButton = styled.button`
	padding: 0;
	margin: 0 0 0 5px;
	border: none;
	cursor: pointer;
	transition: all 0.3
	&:hover {
		.material-icons-outlined {
			color: ${colors.green400};
		}
	}
`;

export const TooltipContent = styled.div`
	font-size: 11px;
	text-align: left;
`;
